module.exports = __webpack_public_path__ + "static/graphicsMobile@2x-446c19ed1448fcdf2d10b27da6436efd.png";